// Utility layer (TS-2.5.04) - pure, no side effects. Resolution helper for the sixth stat card's
// note membership (decisions.md D-285/D-286): a note key (`StatCardValue.memberNoteKeys`) is
// addressed against the SAME `RiskItem` payload every project already carries on
// `ProjectView.risks`, exactly as D-284's `projectsByKey` resolves a member PROJECT key against
// project data it already holds rather than re-deriving or re-fetching. Built from ALL of a
// project's risks - open and closed - so any caller holding a note key can resolve it; the
// open/closed filter is the caller's own job on `RiskItem.isOpen`, not this map's.
import type { ProjectView, RiskItem } from "../../../api/generated/contracts";

export function buildNotesByKey(projectsByKey: ReadonlyMap<string, ProjectView>): ReadonlyMap<string, RiskItem> {
  const notesByKey = new Map<string, RiskItem>();
  for (const project of projectsByKey.values()) {
    for (const risk of project.risks) {
      notesByKey.set(risk.key, risk);
    }
  }
  return notesByKey;
}
